<script>
import { authComputed, authMethods } from '@state/helpers';

export default {
  name: 'ForgotPassConfirmDesktop',
  components: {},
  props: {},
  data() {
    return {
      password: '',
      confirmPassword: '',
      resettingPassword: false,
      showPass: false,
      resetError: '',
      resetSuccess: '',
      passwordMismatch: false,
    };
  },
  methods: {
    ...authMethods,
    toggleShowPasswords() {
      this.showPass = !this.showPass;
    },
    passwordMatch() {
      return this.password === this.confirmPassword;
    },
    emailResetConfirm() {
      this.resetError = '';
      this.resetSuccess = '';
      if (this.password && this.confirmPassword) {
        if (!this.passwordMatch()) {
          this.passwordMismatch = true;
        } else {
          this.mismatchError = '';
          this.resettingPassword = true;
          this.confirmPasswordReset({
            resetType: 'client',
            token: this.$route.query.token,
            newPass: this.password,
          })
            .then((response) => {
              if (response.success) {
                this.resetSuccess = response.message;
                this.password = '';
                this.confirmPassword = '';
                this.resettingPassword = false;
                this.showPass = false;
                this.resetError = '';
                this.passwordMismatch = false;
              } else {
                this.resetError = response.message;
              }
              this.resettingPassword = false;
            })
            .catch((error) => {
              this.resetError = error.message;
              this.resettingPassword = false;
            });
        }
      }
    },
  },
  computed: {
    ...authComputed,
  },
  watch: {
    password(newVal, oldVal) {
      this.passwordMismatch = this.password && this.passwordMismatch;
    },
    confirmPassword(newVal, oldVal) {
      if (newVal === this.password) {
        this.passwordMismatch = false;
      }
    },
  },
};
</script>

<template>
  <div class="container">
    <div class="header">
      <p class="title">
        Reset Password
      </p>
      <p class="subtitle">
        Enter a new password for your account
      </p>
    </div>
    <div class="form">
      <form @submit.prevent="emailResetConfirm">
        <BaseInputText
          autocomplete
          :type="showPass ? 'text' : 'password'"
          classStyle="password"
          placeholder="Password"
          v-model="password"
        />

        <p class="togglePass" @click="toggleShowPasswords">
          {{ showPass ? 'Hide' : 'Show' }}
        </p>

        <BaseInputText
          autocomplete
          :type="showPass ? 'text' : 'password'"
          classStyle="password"
          placeholder="Confirm Password"
          v-model="confirmPassword"
        />
        <div class="to-sign-in">
          <p>
            Ready to Sign In ?
            <router-link class="btn-to-sign-in" to="/login">
              Sign In
            </router-link>
          </p>
        </div>
        <p class="no-match" v-if="passwordMismatch">Passwords don't match</p>

        <div class="forgot-password"> </div>
        <div>
          <div class="reset">
            <BaseButton class="large" type="submit" :disabled="resettingPassword">
              <div v-if="resettingPassword === false">Change Password</div>
              <div v-else><b-spinner /></div>
            </BaseButton>
            <p v-if="resetError" class="error">
              There was an error when resetting your password.
            </p>
            <p v-if="resetSuccess" class="success">
              Your password has been succesfully reset. Try logging in.
            </p>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<style lang="scss">
@media (min-width: 576px) {
  .modal-sm {
    max-width: 375px;
  }
}
</style>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.container {
  align-items: center;
  background: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .header {
    display: flex;
    flex-direction: column;
    margin-bottom: 25px;
    text-align: center;
    width: 100%;

    .title {
      align-self: center;
      font-family: $base-font-family;
      font-size: 42px;
      height: 80px;
      line-height: 80px;
      margin-bottom: 0;
      margin-top: 30px;
    }

    .subtitle {
      align-self: center;
      font-family: $secondary-font-family;
      font-size: 16px;
      font-weight: normal;
      height: 14%;
      margin: 0;

      p {
        margin: 0;
      }
    }
  }

  .form {
    display: block;
    height: 45%;
    margin: 0;
    margin-top: 4%;
    text-align: center;
    width: 100%;

    form {
      height: 100%;
      width: 100%;
      .input-wrapper {
        width: 100%;
        ::v-deep input {
          border-radius: unset;
          padding: 1.31% 5% 3.12% 14%;
          width: 100%;
          &.password {
            border-radius: unset;
            margin-bottom: 0.4rem;
          }
        }
        &.error {
          ::v-deep input {
            margin-bottom: unset;
          }
        }
      }

      .password {
        margin-bottom: 2.4%;
        width: 80%;
      }

      .forgot-password {
        margin-bottom: 60px;
        text-align: right;
      }

      .no-match {
        color: red;
      }

      .reset {
        align-self: flex-end;
        height: 9rem;
        width: 100%;
        button {
          width: 81.75%;
        }
        .error {
          color: red;
          margin-top: 10px;
        }
      }
      .to-sign-in {
        align-self: flex-end;
        font-family: $base-font-family;
        text-align: end;
        width: 95%;

        .btn-to-sign-in {
          color: #4059e1;
          text-decoration: none;
        }
      }
      .togglePass {
        cursor: pointer;
        outline: none;
      }
    }
  }
}
</style>
